import React from 'react';
import { motion } from 'framer-motion';
import { fadeUp } from '../../utils/motion';
type SplitSectionProps = {
  title: string;
  tone?: 'white' | 'muted';
  intro?: string[];
  children?: React.ReactNode;
};
const toneClasses = {
  white: 'bg-white',
  muted: 'bg-surface-bg'
};
export function SplitSection({
  title,
  tone = 'white',
  intro = [],
  children
}: SplitSectionProps) {
  return <section className={`${toneClasses[tone]} py-20 lg:py-28`} data-id="element-1422" data-mp="27a9rl76exwnl">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-1423" data-mp="27cm61acypovw">
        <motion.div {...fadeUp} className="grid grid-cols-1 lg:grid-cols-12 gap-10 lg:gap-16" data-id="element-1424" data-mp="22chrvqzj168u">
          <h2 className="lg:col-span-5 font-heading font-bold text-3xl lg:text-4xl text-ink-dark tracking-tight leading-tight" data-id="element-1425" data-mp="1xjol6xkhznu4">
            {title}
          </h2>
          {intro.length > 0 && <div className="lg:col-span-7 space-y-5" data-id="element-1426" data-mp="2q22jszdnrdu9">
              {intro.map((paragraph, index) => <p key={paragraph} className={index === 0 ? 'text-xl text-ink-dark leading-relaxed' : 'text-lg text-ink-muted leading-relaxed'} data-id="element-1427" data-mp="2l9ivb7dfmyao" data-mpi={index}>
                  {paragraph}
                </p>)}
            </div>}
        </motion.div>
        {children && <div className="mt-12 lg:mt-14" data-id="element-1428" data-mp="6xf7m50yp3m">{children}</div>}
      </div>
    </section>;
}